// Ensure hex code includes #
export const handleHexCode = (hex?: string): string => {
  if (!hex) return '';

  return hex.includes('#') ? hex : `#${hex}`;
};
